var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"battle"},[(_vm.mobile)?_c('iframe',{staticClass:"iframe",attrs:{"width":"100%","frameborder":"0","height":"100%","marginheight":"0","marginwidth":"0","src":_vm.BATTLEHOST}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }